import React from 'react';
import '../../components/text-editor/style.scss';

interface PostUpSellRatingProps {
  ratingValue: number;
  background?: {
    color: string;
    isInherit: boolean;
  };
  maxWidth?: {
    [key: string]: string;
    mobile: string;
    tablet: string;
    desktop: string;
  };
  height?: {
    [key: string]: string;
    mobile: string;
    tablet: string;
    desktop: string;
  };
  currentDeviceType?: 'mobile' | 'tablet' | 'desktop';
  content?: string;
  hideRating?: boolean;
}

export const Startrateing: React.FC<PostUpSellRatingProps> = ({
  ratingValue,
  background,
  height,
  maxWidth,
  currentDeviceType = 'desktop',
  content,
  hideRating = false,
}) => {
  const fullStars = Math.floor(ratingValue);
  const hasHalfStar = ratingValue % 1 >= 0.5;

  const containerStyle: React.CSSProperties = {
    backgroundColor: background?.isInherit ? 'inherit' : background?.color,
  };

  const starStyle: React.CSSProperties =
    currentDeviceType &&
    maxWidth &&
    height &&
    maxWidth[currentDeviceType] !== undefined &&
    height[currentDeviceType] !== undefined
      ? {
          width: isNaN(+maxWidth[currentDeviceType])
            ? maxWidth[currentDeviceType]
            : `${+maxWidth[currentDeviceType]}px`,
          height: isNaN(+height[currentDeviceType])
            ? height[currentDeviceType]
            : `${+height[currentDeviceType]}px`,
        }
      : {};

  return (
    <div className="flex flex-col items-start gap-1">
      <div className="flex items-center gap-2" style={containerStyle}>
        {/* Stars */}
        <div className="flex">
          {[1, 2, 3, 4, 5].map(index => {
            if (index <= fullStars) {
              return (
                <svg
                  key={index}
                  style={starStyle}
                  className="fill-current text-yellow-500"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg">
                  <path d="M10 1.3l2.388 7.49H20l-6.194 4.51L15.622 21 10 16.59 4.377 21l1.813-7.7L0 8.79h7.611z" />
                </svg>
              );
            } else if (index === fullStars + 1 && hasHalfStar) {
              return (
                <svg
                  key={index}
                  style={starStyle}
                  className="fill-current text-yellow-500"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg">
                  <defs>
                    <linearGradient id={`halfGrad-${index}`}>
                      <stop offset="50%" stopColor="#facc15" />
                      <stop offset="50%" stopColor="#d1d5db" />
                    </linearGradient>
                  </defs>
                  <path
                    fill={`url(#halfGrad-${index})`}
                    d="M10 1.3l2.388 7.49H20l-6.194 4.51L15.622 21 10 16.59 4.377 21l1.813-7.7L0 8.79h7.611z"
                  />
                </svg>
              );
            } else {
              return (
                <svg
                  key={index}
                  style={starStyle}
                  className="fill-current text-gray-300"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg">
                  <path d="M10 1.3l2.388 7.49H20l-6.194 4.51L15.622 21 10 16.59 4.377 21l1.813-7.7L0 8.79h7.611z" />
                </svg>
              );
            }
          })}
        </div>
        {!hideRating && (
          <span className="text-sm text-gray-700 font-medium">
            {ratingValue.toFixed(1)}
          </span>
        )}
        {content && (
          <span
            className="text-sm text-gray-500 font-normal checkbox-content"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        )}
      </div>
    </div>
  );
};
